/* import __COLOCATED_TEMPLATE__ from './edit-payout-account-modal.hbs'; */
import Component from '@ember/component';
import { PAYOUT_ACCOUNT } from '../../../models/payout-account';

const CLASS_NAME = 'SH-c-edit-payout-account';

/** @type {Array<Object>} */
const STATUS_OPTIONS = Object.values(PAYOUT_ACCOUNT.STATUSES).map((status) => ({
  value: status,
  label: PAYOUT_ACCOUNT.getStatusText(status),
}));

export default Component.extend({
  tagName: '',

  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {PayoutAccount|null} */
  payoutAccount: null,

  /** @param {Function} */
  onSubmit: () => {},

  /** @param {Function} */
  onModalClose: () => {},

  /** @param {Boolean} */
  isSubmitting: false,

  /** @type {String} */
  _providerId: '',

  /** @type {Number|null} */
  _status: null,

  /** @type {Array<Object>} */
  _statusOptions: STATUS_OPTIONS,

  /** @inheritdoc */
  init() {
    this._super(...arguments);

    this.set('_providerId', this.get('payoutAccount.providerId'));
    this.set('_status', this.get('payoutAccount.status'));
  },

  actions: {
    onProviderIdInput(value) {
      this.set('_providerId', value);
    },

    onStatusRadioClick(value) {
      this.set('_status', value);
    },

    onCancel() {
      this.onModalClose();
    },

    onConfirm() {
      this.get('onSubmit')(this.get('_providerId'), this.get('_status'));
    },
  },
});
